import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo, { JsonLd } from "../components/Seo";

export default function JournalDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api(`/api/posts/${slug}`).then(setPost).catch((err) => setError(err.message));
  }, [slug]);
  if (error) return <Layout><section className="section"><p className="error">{error}</p></section></Layout>;
  if (!post) return <Layout><section className="section">Loading story…</section></Layout>;
  const paragraphs = post.content.split(/\n\n+/);
  return (
    <Layout>
      <Seo title={post.seoTitle || post.title} description={post.seoDescription || post.excerpt} path={`/journal/${post.slug}`} image={post.coverImage} type="article" />
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: post.title,
        datePublished: post.publishedAt,
        author: { "@type": "Person", name: post.author },
        image: post.coverImage,
        description: post.excerpt,
      }} />
      <header className="article-hero" style={{ backgroundImage: `linear-gradient(transparent, rgba(0,0,0,.6)), url(${post.coverImage})` }}>
        <div className="wrap">
          <p className="eyebrow">{post.category} · {post.author}</p>
          <h1 className="display" style={{ fontSize: "clamp(36px, 5vw, 68px)" }}>{post.title}</h1>
        </div>
      </header>
      <article className="section">
        <div className="wrap prose">
          {paragraphs.map((para) => <p key={para.slice(0, 24)}>{para}</p>)}
          {post.photoCredit ? <p className="muted" style={{ marginTop: 28, fontSize: 13 }}>{post.photoCredit}</p> : null}
        </div>
      </article>
    </Layout>
  );
}
